export default "__VITE_ASSET__a8afc083__"